import {BaseMuWidget} from "../BaseMuWidget";
import {RelatedAccountSelector} from "./RelatedAccountSelector";
import {MuNamedWidgets, MuUi, MuWidget} from "mu-widget/lib/MuWidget";
import {UiAccountSelector} from "./UiAccountSelector";
import {oneShotHandler} from "../Utils";


export class TicketAccountSelector extends BaseMuWidget
{
	// @ts-ignore
	public loggedAccountId: number = window.conf.accountId;
	public label: string = "";
	public useAdd: boolean = false;

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		values:UiAccountSelector
	}>;

	// @ts-ignore
	ui: MuUi<{
		valuesDialog: HTMLDialogElement,
	}>;

	public useDelegate = true;

	beforeIndex() {
		this.muAppendContent(`
			<div class="ticket-account-selector gap-1 align-items-center">
				<strong mu="label" class="a-nc"></strong>
				<span style="position: relative">
					<span mu="valuesStr" class="ticket-account-selector__value-str">/span>
					<div mu="values:UiAccountSelector#values" class="ticket-account-selector__value flex-grow-1" style="display: none" mu-params='{"multiple": true}'></div>
				</span>
				<span class="a-nc float-right icon-before-person-swap" mu="bDelegate" title="Vybrat nadřízeného, podřízeného nebo spolupracovníka a odebrat mě">Delegovat</span>
				<span class="a-nc float-right icon-before-add" mu="bAdd" title="Vybrat nadřízeného, podřízeného nebo spolupracovníka">Přidat</span>
			</div>
		`);
	}

	label_click(ev: Event) {
		this.valuesStr_click(ev);
	}

	async  valuesStr_click(ev: Event) {
		ev.stopPropagation();
		this.muVisible(true, 'values');
		this.muNamedWidget.values.focus();

		await oneShotHandler(document, 'click');

		this.muVisible(false, 'values');
	}

	values_click(ev: Event) {
		ev.stopPropagation();
	}

	async bDelegate_click() {
		if (await this.selectAndAdd("Delegovat"))
			this.removeMe();
		this.update();
	}

	async bAdd_click() {
		await this.selectAndAdd("Přidat");
		this.update();
	}


	private removeMe() {
		this.muNamedWidget.values.removeSelected(this.loggedAccountId);
	}

	private async selectAndAdd(label: string): Promise<boolean> {
		const newAccountId = await RelatedAccountSelector.open(label);
		if (newAccountId !== null) {
			this.muNamedWidget.values.addSelected(newAccountId);
		}

		return !!newAccountId;
	}

	values_change() {
		this.update();
	}

	values_changeText() {
		this.updateText();
	}

	private update() {
		const vals = this.muNamedWidget.values.value;
		this.muVisible(vals?.includes(this.loggedAccountId.toString()) && this.useDelegate, 'bDelegate');
		this.updateText();
	}

	private updateText() {
		this.ui.valuesStr.innerHTML = this.muNamedWidget.values.getValueStr();
	}

	afterIndex() {
		this.update();
		this.ui.label.innerText = this.label;
		this.muVisible(this.useAdd, "bAdd");
	}

	muBindData(srcData: any) {
		this.muNamedWidget.values.muBindData(srcData);
	}

	muFetchData(): any {
		return this.muNamedWidget.values.muFetchData();
	}
}

/* export class TicketAccountSelectorOld extends BaseMuWidget
{
	public loggedAccountId: number = 1;
	public label: string = "";
	public useAdd: boolean = false;

	// @ts-ignore
	muNamedWidget: MuNamedWidgets<{
		values:UiAccountSelector
	}>;

	public useDelegate = true;

	beforeIndex() {
		this.muAppendContent(`
			<div class="display-flex gap-1 align-items-center">
				<strong mu="label"></strong>
				<div mu="values:UiAccountSelector#values" mu-params='{"multiple": true}' class="flex-grow-1"></div>
				<span class="btn btn-primary icon-before-person-swap" mu="bDelegate" title="Vybrat nadřízeného, podřízeného nebo spolupracovníka a odebrat mě">Delegovat</span>
				<span class="btn btn-primary icon-before-add" mu="bAdd" title="Vybrat nadřízeného, podřízeného nebo spolupracovníka">Přidat</span>
			</div>
		`);
	}

	async bDelegate_click() {
		if (await this.selectAndAdd("Delegovat"))
			this.removeMe();
		this.update();
	}

	async bAdd_click() {
		await this.selectAndAdd("Přidat");
		this.update();
	}


	private removeMe() {
		this.muNamedWidget.values.removeSelected(this.loggedAccountId);
	}

	private async selectAndAdd(label: string): Promise<boolean> {
		const newAccountId = await RelatedAccountSelector.open(label);
		if (newAccountId !== null) {
			this.muNamedWidget.values.addSelected(newAccountId);
		}

		return !!newAccountId;
	}

	values_change() {
		this.update();
	}

	private update() {
		const vals = this.muNamedWidget.values.value;
		this.muVisible(vals?.includes(this.loggedAccountId.toString()) && this.useDelegate, 'bDelegate');
	}

	afterIndex() {
		this.update();
		this.ui.label.innerText = this.label;
		this.muVisible(this.useAdd, "bAdd");
	}

	muBindData(srcData: any) {
		this.muNamedWidget.values.muBindData(srcData);
	}

	muFetchData(): any {
		return this.muNamedWidget.values.muFetchData();
	}
} */
